import { Trans, useTranslation } from "next-i18next";
import React from "react";
import CallToActionSmall from "../components/v2/call-to-action-sm";
import { Email, Location } from "../components/v2/icons";
import "../styles/scss/contact-us.module.scss";

const iconMap: { [key: string]: React.ReactNode } = {
    Email: <Email/>,
    Location: <Location/>
};

export default function ContactUs() {
    const { t } = useTranslation('common');
    const contactUsData = t('contactUs', { returnObjects: true, defaultValue: {} }) as any;
    
    const heroData = contactUsData?.hero || {};
    const contactInfo = Array.isArray(contactUsData?.contactInfo) ? contactUsData.contactInfo : [];
    const ctaData = contactUsData?.cta || {};

    return (
        <div className="middle-wrapper contact-us">
            <div className={"container"}>
                <div className={"contact"}>
                <div className={"d-flex"}>
                    <div className={"left-block"}>
                        <h1>
                            <Trans 
                                i18nKey="contactUs.hero.title"
                                components={{
                                    highlight: <span className="text-gradient" />
                                }}
                            />
                        </h1>
                        <p>{String(heroData?.description ?? '')}</p>

                        {contactInfo.map((info: any, index: number) => (
                            <div key={index} className={"card-info"}>
                                {iconMap[String(info?.icon ?? '')] || null}
                                <div className={"info"}>
                                    <p>{String(info?.label ?? '')}</p>
                                    <p dangerouslySetInnerHTML={{ __html: String(info?.value ?? '') }}></p>
                                </div>
                            </div>
                        ))}

                    </div>
                    <div className={"right-block"}>
                        
                    <iframe
                        id="surface-iframe"
                        src={process.env.NEXT_PUBLIC_SURFACE_CONTACT_FORM_URL || ''}
                        frameBorder="0"
                        allowFullScreen
                        loading="eager"
                        title="Contact form">
                    </iframe>

                    </div>
                </div>
                </div>
            </div>
            <CallToActionSmall title={String(ctaData?.title ?? '')}/>
        </div>
    )
}